import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Muestreador } from './entity-muestreador.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityMuestreadorLoadRequest = createAction(
  '[ENTITYMUESTREADOR] Load Request'
);

export const entityMuestreadorLoadFailure = createAction(
  '[ENTITYMUESTREADOR] Load Failure',
  props<{ error: Error }>()
);

export const entityMuestreadorLoadSuccess = createAction(
  '[ENTITYMUESTREADOR] Load Success',
  props<{ items: Muestreador[] }>()
);

// ADD
export const entityMuestreadorAddRequest = createAction(
  '[ENTITYMUESTREADOR] Add Request',
  props<{ item: Muestreador }>()
);

export const entityMuestreadorAddFailure = createAction(
  '[ENTITYMUESTREADOR] Add Failure',
  props<{ error: Error }>()
);

export const entityMuestreadorAddSuccess = createAction(
  '[ENTITYMUESTREADOR] Add Success',
  props<{ item: Muestreador }>()
);

// CHANGE
export const entityMuestreadorChangeRequest = createAction(
  '[ENTITYMUESTREADOR] Change Request',
  props<{ item: Muestreador }>()
);

export const entityMuestreadorChangeFailure = createAction(
  '[ENTITYMUESTREADOR] Change Failure',
  props<{ error: Error }>()
);

export const entityMuestreadorChangeSuccess = createAction(
  '[ENTITYMUESTREADOR] Change Success',
  props<{ item: Update<Muestreador> }>()
);

// DELETE
export const entityMuestreadorDeleteRequest = createAction(
  '[ENTITYMUESTREADOR] Delete Request',
  props<{ item: Muestreador }>()
);

export const entityMuestreadorDeleteFailure = createAction(
  '[ENTITYMUESTREADOR] Delete Failure',
  props<{ error: Error }>()
);

export const entityMuestreadorDeleteSuccess = createAction(
  '[ENTITYMUESTREADOR] Delete Success',
  props<{ item: Muestreador }>()
);
